import { defineComponent as _defineComponent } from 'vue'
import { DOMUtils } from '@/utils/dom_utils';
import { onMounted, ref } from 'vue';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContextMenu',
  props: {
    border: { type: Boolean, required: false },
    buttons: { type: Array, required: true },
    size: { type: String, required: false }
  },
  setup(__props: any, { expose: __expose }) {

const isShowingContextMenu = ref(false);
const contextMenuElem = ref<HTMLDivElement>();
const quadrant = ref({
  isSuperior: false,
  isLeft: false,
});

const props = __props;

__expose({
  getElement: () => contextMenuElem.value,
});

onMounted(() => {
  quadrant.value = DOMUtils.detectQuadrant(contextMenuElem.value!);
});


const __returned__ = { isShowingContextMenu, contextMenuElem, quadrant, props, get FontAwesomeIcon() { return FontAwesomeIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})